import {
  assign, endpoint, check, convert,
} from '../helpers';
import { User } from '../../tools';

/**
 * Loads the exported report schema into the server
 *
 * @function
 * @param {Object} properties All parameters to be used in the function
 */

const download = (properties) => {
  const props = assign(properties);

  fetch(endpoint(`/${User.getToken()}/downloadfile/${props.data.file}`, 'media'), {
    method: 'POST',
  })
    .then(response => response.json())
    .then((response) => {
      check(response.Token);
      if (response.Success) {
        props.success(convert(response.Message));
      } else {
        props.error(convert(response.Message));
      }
    })
    .catch(output => window.console.warn(output));
};

export default download;
